import React from 'react';
import pt from 'prop-types';
import { Typography } from '@metarouter-private/mr-mui';

export default function RemoveFromBundleMessage({ type, fileName }) {
  return (
    <Typography>
      By removing this {type} from the {fileName} file you will prevent it from triggering on a page load.
    </Typography>
  );
}

RemoveFromBundleMessage.propTypes = {
  type: pt.string,
  fileName: pt.string,
};
